document.addEventListener("click", function(e) {

  if (e.target.classList.contains("cutting-toggle-btn")) {

    let key = e.target.dataset.key;
    let target = document.getElementById("cutting-" + key);

    if (!target) return;

    let isOpen = target.style.display === "block";

    // Close all first (optional - accordion behavior)
    document.querySelectorAll(".cutting-content").forEach(el => {
      el.style.display = "none";
    });

    document.querySelectorAll(".cutting-toggle-btn").forEach(btn => {
      btn.innerHTML = `Cutting Preferences 
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 16 9" fill="">
          <path d="M7.42935 8.55099C7.74027 8.86191 8.25973 8.86191 8.57145 8.55099L15.7638 1.37702C16.0787 1.06211 16.0787 0.551424 15.7638 0.237317C15.4489 -0.0775875 14.9374 -0.0775875 14.6225 0.237317L8.00003 6.8414L1.37834 0.236518C1.06264 -0.0783866 0.551947 -0.0783866 0.236246 0.236518C-0.0786586 0.551422 -0.0786587 1.06211 0.236246 1.37622L7.42935 8.55099Z" fill=""/>
          </svg>
        </span>`;
    });

    // Toggle current
    if (!isOpen) {
      target.style.display = "block";

      e.target.innerHTML = `Cutting Preferences 
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 16 9" fill="">
          <path d="M8.57065 0.233189C8.25973 -0.0777296 7.74027 -0.0777296 7.42855 0.233189L0.236178 7.40716C-0.0787261 7.72207 -0.0787261 8.23276 0.236178 8.54686C0.551083 8.86177 1.06257 8.86177 1.37747 8.54686L7.99997 1.94277L14.6217 8.54766C14.9374 8.86256 15.4481 8.86256 15.7638 8.54766C16.0787 8.23276 16.0787 7.72207 15.7638 7.40796L8.57065 0.233189Z" fill=""/>
          </svg>
        </span>`;
    }

  }

});
  function showStatus(key, text, type = '') {
    const el = document.querySelector(`.save-status[data-key="${key}"]`);
    if (!el) return;

    el.textContent = text;
    el.className = `save-status ${type}`;

    if (type === 'success') {
      setTimeout(() => el.textContent = '', 2000);
    }
  }


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cutting-input').forEach(input => {

    input.addEventListener('blur', function () {
      const key = this.dataset.key;
      const propertyName = this.dataset.properties;
      const value = this.value.trim();

      if (!key || !propertyName) return;
      showStatus(key, 'Saving...', 'loading');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          properties: {
            [propertyName]: value
          }
        })
      })
      .then(res => res.json())
      .then(data => {
              showStatus(key, 'Saved ✓', 'success');
                      input.style.border = "";

              console.log('Cart updated', data);
      })
      .catch(err => {
              showStatus(key, 'Error!', 'error');

        console.error('Error updating cart:', err);
      });

    });

  });
});

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.slider-container').forEach(container => {

    const slider = container.querySelector('.related-slider');

    // ❌ Skip if grid mode
    if (!slider || slider.classList.contains('grid-mode')) return;

    const next = container.querySelector('.next');
    const prev = container.querySelector('.prev');

    if (!next || !prev) return;

    let autoPlay; // ✅ scoped per slider

    function getScrollAmount() {
      const card = slider.querySelector('.related-card');
      if (!card) return 300;
      return card.offsetWidth + 20;
    }

    function slideNext() {
      const scrollAmount = getScrollAmount();

      if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 5) {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        slider.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      }
    }

    // 👉 Buttons
    next.addEventListener('click', slideNext);

    prev.addEventListener('click', () => {
      slider.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
    });

    // 👉 Start autoplay (safe)
    function startAutoPlay() {
      stopAutoPlay(); // ✅ prevent stacking
      autoPlay = setInterval(slideNext, 2500);
    }

    function stopAutoPlay() {
      if (autoPlay) {
        clearInterval(autoPlay);
        autoPlay = null;
      }
    }

    // 👉 Init autoplay
    startAutoPlay();

    // 👉 Pause on hover
    container.addEventListener('mouseenter', stopAutoPlay);
    container.addEventListener('mouseleave', startAutoPlay);

    // 👉 Optional: Pause when tab inactive (performance boost)
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoPlay();
      } else {
        startAutoPlay();
      }
    });

  });

});